import { Identifier } from '../types';

interface Cache {
    [key: string]: boolean | undefined,
}

const favoritesCache: Cache = {};

class FavoritesCache {
    static setFavorite(lessonId: Identifier, isFavorite: boolean | undefined) {
        favoritesCache[String(lessonId)] = isFavorite;
    }

    static getFavoriteStatus(lessonId: Identifier): boolean | undefined {
        const key = String(lessonId);

        if (key in favoritesCache) {
            return favoritesCache[key];
        }

        return undefined;
    }
}

export default FavoritesCache;
